import * as types from '../types';
export const setItemOffset = (id, itemId, offset) => ({
  id,
  itemId,
  offset,
  type: types.SET_ITEM_OFFSET
});
const orderGroupedItems = (id, groupedItems) => ({
  groupedItems,
  id,
  type: types.ORDER_GROUPED_ITEMS
});
export default orderGroupedItems;